import { Observable, Subject } from 'rxjs';
import { OverlayRef } from '@angular/cdk/overlay';

export class DialogRef<T = boolean> {
  private afterClosedSubject = new Subject<T>();

  constructor(private overlayRef: OverlayRef) {}

  public close(result: T) {
    this.overlayRef.dispose();
    this.afterClosedSubject.next(result);
    this.afterClosedSubject.complete();
  }

  public closed$(): Observable<T> {
    return this.afterClosedSubject.asObservable();
  }
}
